import styled from '@emotion/styled';
import { boxSizes, colors, gutterSizes } from '../base/theme';

export const RadioListTitle = styled.h3<{ title: string }>`
    margin-bottom: ${(props) => (props.title.length > 0 ? gutterSizes.xxlarge : gutterSizes.large)};
`;

export const RadioListUl = styled.ul<{ border: boolean }>`
    & > li {
        margin-bottom: ${gutterSizes.xxlarge};

        ${({ border }) => border && `
            border: 1px solid ${colors.newBorder};
            border-radius: ${boxSizes.borderRadius4};
            margin-bottom: ${gutterSizes.base};
            padding: ${gutterSizes.large};
        `}
    }
`;
